import { atom } from 'recoil';
import { IIdioma } from '../../../commons/types/config';

export const idiomaAtom = atom<IIdioma[]>({
  key: 'idioma',
  default: [] as IIdioma[],
});
